export default __webpack_public_path__ + "static/media/path-cut-smooth-full.166a9cfd.gif";